import { SelectChangeEvent, Select, MenuItem, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import i18n from "../../config/i18n";
import { useTranslation } from "react-i18next";

type LanguageCode = 'pt' | 'es' | 'en';

const LanguageSelect = () => {
    const [language, setLanguage] = useState<LanguageCode>(() => {
        return (sessionStorage.getItem('appLanguage') as LanguageCode) || 'pt';
    });

    const { t } = useTranslation();

    const handleLanguageChange = (event: SelectChangeEvent) => {
        const selectedLanguage = event.target.value as LanguageCode;
        setLanguage(selectedLanguage);
        sessionStorage.setItem('appLanguage', selectedLanguage);
    };

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);

    const menuItemStyles = {
        fontWeight: 'bold',
        fontSize: '14px',
        padding: '4px 2px',
        '&:focus': {
            backgroundColor: 'transparent',
        },
    };

    return (
        <>
            {/* InputLabel fornece um nome acessível */}
            <InputLabel id="language-select-label" sx={{ display: "none" }}>
                {t("Selecione o idioma")} {/* Texto traduzido para acessibilidade */}
            </InputLabel>
            <Select
                labelId="language-select-label" // Associa o Select ao InputLabel
                value={language}
                onChange={handleLanguageChange}
                sx={{
                    fontFamily: "bold",
                    color: "white",
                    borderRadius: 0,
                    border: '1px solid white',
                    height: '35px',
                    minWidth: 'auto',
                    '& .MuiSelect-icon': {
                        color: 'white',
                    },
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                    },
                    '&.Mui-focused': {
                        outline: 'none',
                        boxShadow: 'none',
                        borderColor: 'white',
                    },
                    '&:focus': {
                        outline: 'none',
                        borderColor: 'white',
                    },
                    boxShadow: 'none',
                }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    },
                    disableScrollLock: true,
                    disableEscapeKeyDown: false,
                }}
            >
                <MenuItem value={"pt"} aria-label={t("Português")} sx={menuItemStyles}>
                    PT
                </MenuItem>
                <MenuItem value={"es"} aria-label={t("Espanhol")} sx={menuItemStyles}>
                    ES
                </MenuItem>
                <MenuItem value={"en"} aria-label={t("Inglês")} sx={menuItemStyles}>
                    EN
                </MenuItem>
            </Select>
        </>
    );
};

export default LanguageSelect;
